import { arrayRequired, labeled } from '../../util/joi';
import { schema as securitySchema } from '../finance/Security.schema';
import { schema as titleSchema } from './HomeLoanTitle.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    securitySplits: arrayRequired(Joi, securitySchema(Joi, labeled(label, 'Security -')))
      .min(1)
      .label(labeled(label, 'Security -')),
    titleDetails: arrayRequired(Joi, titleSchema(Joi, labeled(label, 'Title details -')))
      .min(1)
      .label(labeled(label, 'Title details -'))
  });

export default {
  schema
};
